import type {FC} from 'react';
import clsx from 'clsx';
import Link from 'next/link';
import {checkIfLinkShouldUseAnchorTag} from 'utils';

import type {CallToActionColorSchema} from 'components/call-to-action/schema';

interface BaseProps {
	text: string;
	color: CallToActionColorSchema;
}

interface LinkProps {
	href?: string;
	targetBlank?: boolean;
}

interface ButtonProps {
	onClick?: () => void;
}

type Props = BaseProps & (LinkProps | ButtonProps);

export const CallToActionRender: FC<Props> = (props) => {
	const {text, color} = props;
	const href = 'href' in props ? props.href : undefined;
	const targetBlank = 'targetBlank' in props ? props.targetBlank : undefined;
	const onClick = 'onClick' in props ? props.onClick : undefined;

	const buttonPrimary = clsx('bg-primary-main', 'hover:bg-primary-light', 'text-white');
	const buttonSecondary = clsx(
		'bg-transparent',
		'hover:bg-primary-light',
		'hover:text-white',
		'text-primary-main',
	);

	const linkShouldUseAnchorTag = checkIfLinkShouldUseAnchorTag(href);
	const className = clsx(
		color === 'primary' ? buttonPrimary : buttonSecondary,
		'px-6',
		'py-3',
		'text-base',
		'inline-block',
		'rounded-md',
		'text-center',
		'w-full',
		'sm:w-auto',
		'transition-colors',
		'border',
		'border-primary-main',
		'hover:border-primary-light',
	);

	if (onClick) {
		return (
			<button className={className} onClick={onClick}>
				{text}
			</button>
		);
	}

	if (linkShouldUseAnchorTag) {
		return (
			<a className={className} href={href ?? '#'} target={targetBlank ? '_blank' : undefined}>
				{text}
			</a>
		);
	}

	return (
		<Link className={className} href={href ?? '#'} target={targetBlank ? '_blank' : undefined}>
			{text}
		</Link>
	);
};
